import api from "@/services/api";
import { SaleType } from "@/types/sale/Sale";

class GetAllIndications {
  execute = async (startDate: String | undefined, endDate: String | undefined) => {
    const indicationsListener = await api().get(`/transactions`, {
      params: {
        startDate: startDate,
        endDate: endDate,
        status: "CONFIRMED",
        type: "INDICATION_BONUS",
      },
    });
    return indicationsListener.data as SaleType[];
  };
}

export { GetAllIndications };
